import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FileInput from 'components/form/FileInput'
import ErrorText from 'components/form/ErrorText'
import NoneAnchor from 'components/NoneAnchor'

const DocumentFileItem = ({
  reviewDocumentType,
  uploadDocuments,
  handleFileUpload,
  handleDownloadTempFile,
  handleFileDelete,
}) => {
  const [error, setError] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(uploadDocuments.length > 0)
  }, [uploadDocuments])

  return (
    <>
      <li
        className={classNames({
          open: isOpen,
          file_on: uploadDocuments.length > 0,
        })}>
        <strong className="tit_document">
          <FileInput
            clearFiles
            accept=".jpg,.jpeg,.gif,.png,.tif,.hwp,.doc,.docx,.pdf"
            onFileChange={files => {
              handleFileUpload(files[0], setError)
              setIsOpen(true)
            }}>
            <button className="btn_gs" onClick={e => e.preventDefault()}>
              <span className="inner_g">파일업로드</span>
            </button>
          </FileInput>
          <div
            className="link_fold"
            onClick={() => {
              uploadDocuments.length > 0 && setIsOpen(!isOpen)
            }}>
            {reviewDocumentType}{' '}
            <em className="txt_num">{uploadDocuments.length}</em>
          </div>
        </strong>
        <div className="list_file">
          {uploadDocuments.map(document => (
            <div key={document.fileId} className="item_file ">
              <NoneAnchor
                className="file_name"
                style={{ color: '#555' }}
                onClick={() => handleDownloadTempFile(document.fileId)}>
                {document.name}
              </NoneAnchor>
              <NoneAnchor
                className="link_del"
                onClick={() => handleFileDelete(document.fileId)}>
                <span className="ico_comm ico_del">삭제</span>
              </NoneAnchor>
            </div>
          ))}
          {error && (
            <div className="item_file ">
              <span className="file_name">
                <ErrorText error="업로드한 파일 용량을 확인 후 다시 시도하세요." />
              </span>
            </div>
          )}
        </div>
      </li>
    </>
  )
}

export default DocumentFileItem

DocumentFileItem.propTypes = {
  reviewDocumentType: PropTypes.string.isRequired,
  uploadDocuments: PropTypes.array.isRequired,
  handleFileDelete: PropTypes.func,
  handleFileUpload: PropTypes.func,
  handleDownloadTempFile: PropTypes.func,
}
